module.exports = __webpack_public_path__ + "static/media/team.86208249.svg";